
import {defineComponent} from 'vue'

const __default__ = defineComponent({
    name: 'CardBackground',

    props: {
        tilt: {
            type: Object,
            required: true,
        },

        tiltAngle: {
            type: Number,
            required: true,
        },

        bgUrl: {
            type: String,
            required: true,
        },
    },

    computed: {
        computedTilt(): string
        {
            const x = 50 + 15 * (this.tilt.x / this.tiltAngle)
            const y = 50 - 25 * (this.tilt.y / this.tiltAngle)
            return `${x}% ${y}%`
        },
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "541bd630": (`url("/img/page/landing/registration/cardBg/${_ctx.bgUrl}")`),
  "9a834782": (_ctx.computedTilt)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__